import React from 'react';
import { Typography, Grid, Button } from '@mui/material';
import CommonModal from '../Common/CommonModal';
import Text from '../Common/Text';
import { trakrefBlue } from '../../color_utils';
import { trakrefFontFamily } from '../../utils';

const bodyPadding={ padding: '0% 8%' };

const ServiceEventModal = ({
    open,
    close,
    header,
    mainBodyText,
    onClick,
    buttonsDisabled,
    buttonText1,
    buttonText2,
}) => (
    <CommonModal
        open={open}
        close={close}
        header={header}
        bottom={10}
    >
        <Grid container>
            <Grid item xs={12} lg={12} align='center' sx={bodyPadding}>
                <Text
                    text={mainBodyText}
                    variant="h5"
                    marginBottom={6}
                />
            </Grid>
            <Grid item xs={12} lg={12} align='center'>
                <Button
                    fullWidth
                    variant='contained'
                    onClick={onClick}
                    disabled={buttonsDisabled}
                    style={{
                        backgroundColor: trakrefBlue,
                        marginBottom: '3%',
                        width: '80%'
                    }}
                >
                    <Typography
                        variant='h6'
                        sx={{
                            padding: '2% 0%',
                            color: '#fff',
                            
                        }}
                    >
                        {buttonText1}
                    </Typography>
                </Button>
            </Grid>
            <Grid item xs={12} lg={12} align='center'>
                <Button
                    variant='outlined'
                    fullWidth
                    onClick={close}
                    disabled={buttonsDisabled}
                    style={{ width: '80%', marginBottom: '4%' }}
                >
                    <Typography
                        variant='h6'
                        sx={{
                            padding: '2% 0%',
                            color: trakrefBlue,
                            
                        }}
                    >
                        {buttonText2}
                    </Typography>
                </Button>
            </Grid>
        </Grid>
    </CommonModal>
);

export default ServiceEventModal;
